"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GrowthBookProvider", {
  enumerable: true,
  get: function get() {
    return _growthbookReact.GrowthBookProvider;
  }
});
Object.defineProperty(exports, "GrowthBookReact", {
  enumerable: true,
  get: function get() {
    return _growthbookReact.GrowthBook;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "useFeatureIsOn", {
  enumerable: true,
  get: function get() {
    return _growthbookReact.useFeatureIsOn;
  }
});
Object.defineProperty(exports, "useFeatureValue", {
  enumerable: true,
  get: function get() {
    return _growthbookReact.useFeatureValue;
  }
});
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _growthbookReact = require("@growthbook/growthbook-react");
var _excluded = ["event"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var onExperimentViewed = function onExperimentViewed(experiment, result) {
  var data = {
    event: 'experiment_viewed',
    experiment_id: experiment.key,
    variation_id: result.variationId
  };
  setTimeout(function () {
    var _global;
    var event = data.event,
      attributes = _objectWithoutProperties(data, _excluded);
    var attributesList = attributes;
    (_global = global) === null || _global === void 0 || (_global = _global.Moengage) === null || _global === void 0 || _global.track_event(event, attributesList);
    console.log('pushed to Moengage', data);
    if ((0, _isArray2["default"])(global.dataLayer)) {
      var _global2;
      console.log('pushed to GA4', data);
      (_global2 = global) === null || _global2 === void 0 || (_global2 = _global2.dataLayer) === null || _global2 === void 0 || _global2.push(data);
    }
  }, 3200);
};
var initClient = function initClient(growthBookOptions) {
  var clientID = '';
  try {
    var _document;
    clientID = (_document = document) === null || _document === void 0 || (_document = _document.cookie) === null || _document === void 0 || (_document = _document.match(/_ga=(.+?);/)[1]) === null || _document === void 0 || (_document = _document.split('.')) === null || _document === void 0 || (_document = _document.slice(-2)) === null || _document === void 0 ? void 0 : _document.join('.');
  } catch (error) {
    console.log('Error getting cookie:', error);
  }
  var attributes = {
    trackingCallback: onExperimentViewed,
    attributes: {
      id: clientID,
      clientId: clientID
    }
  };
  return new _growthbookReact.GrowthBook(_objectSpread(_objectSpread({}, growthBookOptions), attributes));
};
var _default = exports["default"] = initClient;